import React, { Component } from 'react';
import debounce from 'lodash/debounce';
import SearchDropDownWrapper from '../SearchDropDownWrapper/SearchDropDownWrapper';
import BaseSelect from 'components/common/BaseSelect/BaseSelect';

class SearchDropDownAsync extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      inputValue: '',
    };
  }

  setStateSave(state, callback) {
    if (this._isMounted) {
      this.setState(state, callback);
    }
  }

  async UNSAFE_componentWillMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  onLoad = async () => {
    if (this.props.nextPageExist) {
      this.setStateSave({ isLoading: true });
      await this.props.onLoad();
      this.setStateSave({ isLoading: false });
    }
  };

  onInputChange = debounce((value) => {
    const possibleMatch = this.props.options.findIndex((option) => option.label.toLowerCase().includes(value)) !== -1;

    const asyncInputChange = async () => {
      if (value !== this.state.inputValue) {
        this.setStateSave({ inputValue: value, isLoading: true });
        await this.props.onInputChange(value);
        this.setStateSave({ isLoading: false });
      }
    };

    if (!possibleMatch) {
      asyncInputChange();
    }
  }, 750);

  render() {
    return (
      <SearchDropDownWrapper {...this.props}>
        <BaseSelect
          defaultSelect={false}
          isSearchable
          isClearable={this.props.clearable != null ? this.props.clearable : true}
          onChange={(option) => this.props.onChange(option)}
          value={this.props.selectedId}
          placeholder={this.props.placeholder || 'All'}
          closeMenuOnSelect
          label={this.props.label}
          options={this.props.options}
          onInputChange={this.onInputChange}
          onMenuScrollToBottom={this.onLoad}
          noOptionsMessage={() => (this.state.isLoading ? 'Loading...' : 'No results found')}
          isLoading={this.state.isLoading || this.props.isLoading}
          onMenuOpen={() => this.props.onOpen && this.props.onOpen()}
        />
      </SearchDropDownWrapper>
    );
  }
}

export default SearchDropDownAsync;
